import { cn } from '@/shared/utils/cn';
import { Link } from '@/shared/components/link/link';
import { BigCommerceImage } from '@/shared/components/primitives/bigcommerce-image';

type ImageSize = 'square' | 'tall' | 'wide';

type GameImageProps = {
  image?: {
    url: string;
    altText: string | null;
  } | null;
  href?: string;
  imageSize?: ImageSize;
  sizes?: string;
  onClick?: () => void;
};

export const GameImageDisplay = ({
  image,
  href,
  imageSize = 'square',
  sizes,
  onClick,
}: GameImageProps) => {
  return (
    <div
      className={cn('relative flex-auto', {
        'aspect-square': imageSize === 'square',
        'aspect-[4/5]': imageSize === 'tall',
        'aspect-[7/5]': imageSize === 'wide',
      })}
    >
      {image ? (
        href ? (
          <Link
            className='relative block h-full w-full text-white hover:text-gray-400'
            href={href}
            onClick={onClick}
          >
            <BigCommerceImage
              alt={image?.altText || ''}
              className='object-contain'
              fill
              src={image.url}
              sizes={sizes}
            />
          </Link>
        ) : (
          <BigCommerceImage
            alt={image?.altText || ''}
            className='object-contain'
            fill
            src={image.url}
            sizes={sizes}
          />
        )
      ) : (
        <div className='h-full w-full bg-gray-200' />
      )}
    </div>
  );
};
